export const formatTimeByZone = (
  epochMs: number,
  locale = navigator.language,
) => {
  const loc = locale !== 'ROW' ? locale : 'en-US'
  const date = new Date(epochMs)
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const result = new Intl.DateTimeFormat(loc, {
    timeZone,
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
  }).format(date)

  return result
}
